import script from "./OrderForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderForm.vue?vue&type=script&lang=ts&setup=true"

import "./OrderForm.vue?vue&type=style&index=0&id=45fa951c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45fa951c"]])

export default __exports__